import { FC, useState } from 'react';
import { Copy, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PricingRule } from '@libs/schemas';
import { ConfirmDialog } from 'components/ConfirmDialog';

interface RuleActionsMenuProps {
  rule: PricingRule;
  onEdit: (rule: PricingRule) => void;
  onDelete?: (rule: PricingRule) => void;
  onDuplicate?: (rule: PricingRule) => void;
}

export const RuleActionsMenu: FC<RuleActionsMenuProps> = ({
  rule,
  onEdit,
  onDelete,
  onDuplicate,
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click event
    onEdit(rule);
  };

  const handleDuplicate = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click event
    setShowDuplicateConfirm(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row click event
    setShowDeleteConfirm(true);
  };

  return (
    <>
      <Button variant="ghost" size="icon" onClick={handleEdit} className="h-8 w-8">
        <Pencil className="h-4 w-4" />
      </Button>
      <Button variant="ghost" size="icon" onClick={handleDuplicate} className="h-8 w-8">
        <Copy className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleDelete}
        className="h-8 w-8 text-red-600 hover:text-red-700"
      >
        <Trash2 className="h-4 w-4" />
      </Button>

      <ConfirmDialog
        open={showDuplicateConfirm}
        onOpenChange={setShowDuplicateConfirm}
        title="Duplicate Pricing Rule"
        description={`Are you sure you want to create a copy of rule ${rule.name}?`}
        confirmText="Duplicate"
        onConfirm={() => onDuplicate?.(rule)}
        variant="default"
      />

      <ConfirmDialog
        open={showDeleteConfirm}
        onOpenChange={setShowDeleteConfirm}
        title="Delete Pricing Rule"
        description={`Are you sure you want to delete rule ${rule.name}? This action cannot be undone.`}
        confirmText="Delete"
        onConfirm={() => onDelete?.(rule)}
        variant="destructive"
      />
    </>
  );
};
